import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';
import ActionButton from '../../../../../Components/Common/ActionButton';

const CrudeCounterOfferModal = ({ isOpen, crude, onClose, onSubmit }) => {
  const [alphaDyedCounter, setAlphaDyedCounter] = useState('');
  const [alphaUndyedCounter, setAlphaUndyedCounter] = useState('');

  useEffect(() => {
    if (isOpen) {
      setAlphaDyedCounter('');
      setAlphaUndyedCounter('');
    }
  }, [isOpen]);

  const handleSubmit = () => {
    onSubmit({
      alphaDyedCounter:
        alphaDyedCounter !== '' ? Number(alphaDyedCounter) : null,
      alphaUndyedCounter:
        alphaUndyedCounter !== '' ? Number(alphaUndyedCounter) : null,
    });
    onClose();
  };

  const crudeName = crude?.crudeName ?? '';

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Counter Offer — {crudeName}</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Alpha Dyed Counter</Label>
              <Input
                type='number'
                min={0}
                value={alphaDyedCounter}
                onChange={e => setAlphaDyedCounter(e.target.value)}
                placeholder='Masukkan nilai'
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Alpha Undyed Counter</Label>
              <Input
                type='number'
                min={0}
                value={alphaUndyedCounter}
                onChange={e => setAlphaUndyedCounter(e.target.value)}
                placeholder='Masukkan nilai'
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <ActionButton
          variant='secondary'
          icon='ri-close-line'
          onClick={onClose}
        >
          Cancel
        </ActionButton>
        <ActionButton
          variant='primary'
          icon='ri-send-plane-line'
          onClick={handleSubmit}
        >
          Submit
        </ActionButton>
      </ModalFooter>
    </Modal>
  );
};

export default CrudeCounterOfferModal;
